import React from "react";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import './Resume.css'

function Resume_Certificate() {
    const isSmallScreen = window.innerWidth <= 300;
    
    return (
        <Card className={"resume-card"}>
            <h1 className={"resume-card-title"}>Certificates</h1>
            <br></br>
            <Row>
          {/* 첫 번째 열 (연도) */}
            <Col xs={isSmallScreen ? 4 : 3} className="text-center res-year">
                <Row>
                    <p> 2024.06 </p>
                </Row>
                
                <Row>
                    <p> 2023.08 </p>
                </Row>

                <Row>
                    <p> 2023.05 </p>
                </Row>

                <Row>
                    <p> 2022.03 </p>
                </Row>

                <Row>
                    <p> 2021.08 </p>
                </Row>

                <Row>
                    <p> 2021.04 </p>
                </Row>

                <Row>
                    <p> 2021.04 </p>
                </Row>

                <Row>
                    <p> 2020.09 </p>
                </Row>
            </Col>
            {/* 두 번째 열 (세로 선) */}
            <Col xs={1} className="text-center">
                <div className="vertical-line"></div>
            </Col>
            {/* 세 번째 열 */}
            <Col xs={isSmallScreen ? 6 : 4} className="text-center res-edu-text">
                <Row>
                    <p> 빅데이터분석기사 </p> <br></br>
                </Row>
                <Row>
                    <p> AWS SAA </p> <br></br>
                </Row>
                <Row>
                    <p> DAsP </p> <br></br>
                </Row>
                <Row>
                    <p> ADsP </p> <br></br>
                </Row>
                <Row>
                    <p> 정보처리기사 </p> <br></br>
                </Row>
                <Row>
                    <p> 리눅스마스터 2급 </p> <br></br>
                </Row>
                <Row>
                    <p> SQLD </p> <br></br>
                </Row>
                <Row>
                    <p> 컴퓨터활용능력 2급 </p>
                </Row>
            </Col>

            {/* 네 번째 열 */}
            {!isSmallScreen && (
                <Col xs={4} className="text-center res-edu-text">
                    <Row>
                        <p> 한국데이터산업진흥원</p> <br></br>
                    </Row>
                    <Row>
                        <p> AWS </p> <br></br>
                    </Row>
                    <Row>
                        <p> 한국데이터산업진흥원</p> <br></br>
                    </Row>
                    <Row>
                        <p> 한국데이터산업진흥원</p> <br></br>
                    </Row>
                    <Row>
                        <p> 한국산업인력공단</p> <br></br>
                    </Row>
                    <Row>
                        <p> 한국정보통신산업진흥협회</p> <br></br>
                    </Row>
                    <Row>
                        <p> 한국데이터산업진흥원</p> <br></br>
                    </Row>
                    <Row>
                        <p> 대한상공회의소 </p>
                    </Row>
                </Col>
            )}
        </Row>
        </Card>
    )
}

export default Resume_Certificate;